import { createActionConst } from '../../../utils/action.utils';

const CHART_NAMESPACE = 'CHART';

export const STORE_CHART = createActionConst(CHART_NAMESPACE, 'STORE_CHART');
export const CLEAR_CHART = createActionConst(CHART_NAMESPACE, 'CLEAR_CHART');
